"use strict";

(function () {
  if (customElements.get("number-input-btn")) return;

  class NumberInputBtn extends HTMLElement {
    constructor() {
      super();
      this._targetInput = null;
      this._action = this.getAttribute("action"); // 'up' or 'down'

      // Bind the click handler once
      this._handleClick = this._handleClick.bind(this);
    }

    connectedCallback() {
      // Find the target input using the 'for' attribute
      const targetId = this.getAttribute("for");
      if (!targetId) {
        console.error(
          'NumberInputBtn requires a "for" attribute to target an input id.',
        );
        return;
      }
      this._targetInput = document.getElementById(targetId);

      if (!this._targetInput) {
        console.error(
          `NumberInputBtn could not find an element with id: "${targetId}"`,
        );
        return;
      }

      this.addEventListener("click", this._handleClick);
    }

    disconnectedCallback() {
      this.removeEventListener("click", this._handleClick);
    }

    _handleClick() {
      if (
        !this._targetInput ||
        this.hasAttribute("disabled") ||
        this._targetInput.hasAttribute("disabled")
      ) {
        return;
      }

      // Perform the correct action based on the 'action' attribute
      if (this._action === "up") {
        this._targetInput.stepUp();
      } else if (this._action === "down") {
        this._targetInput.stepDown();
      }

      // IMPORTANT: Manually changing the value with stepUp/stepDown does not
      // fire a 'change' or 'input' event. We must do it ourselves so that
      // any other code listening for changes on the input will work correctly.
      const changeEvent = new Event("change", { bubbles: true });
      this._targetInput.dispatchEvent(changeEvent);
    }
  }

  customElements.define("number-input-btn", NumberInputBtn);
})();
